// extracted by mini-css-extract-plugin
export default {"mt4":"registerPage_mt4__hfBmM","mt8":"registerPage_mt8__5CgV1","mt12":"registerPage_mt12__IHweN","font-size":"registerPage_font-size__Ric9t"};